import { SelectOption } from "@shared/components/ui/select/select.component";

export interface VendorOption extends SelectOption {
  // Solo para vendedores que no son tenants; el resto toma tenantColor del environment
  color?: string;
}

export const VENDOR_OPTIONS: VendorOption[] = [
  { value: "plazaVea", label: "plazaVea" },
  { value: "Oechsle", label: "Oechsle" },
  { value: "Promart", label: "Promart" },
  { value: "Real Plaza", label: "Real Plaza" },
  { value: "Vivanda", label: "Vivanda" },
  { value: "Shopstar", label: "Shopstar" },
  { value: "Agora Shop", label: "Agora Shop", color: "#03CCFF" },
  { value: "Sellercenter", label: "Sellercenter" },
];

export const TIPIFICATION_DEFAULTS = {
  ORG_ID: "156829b6-000b-499f-bfdd-1f8342458860",
  ATTRIBUTE_TYPE_TIENDA: "6",
  ATTRIBUTE_TYPE_SUBTIENDA: "7",
  ATTRIBUTE_TYPE_SOLUCIONADA: "8",
  ATTRIBUTE_TYPE_INCIDENCIA: "9",
  ATTRIBUTE_TYPE_DOCUMENTO: "4",
  PROVISIONAL: false,
  DEFAULT_TYPE_INTERACTION: "emails",
  SELLER_TYPE: "22",
} as const;

export const TIPIFICATION_MESSAGES = {
  SUCCESS: "Tipificación exitosa",
  ERROR: "Error al tipificar",
  VALIDATION_ERROR: "Datos incompletos para tipificación",
} as const;
